<script>
import StarRating from 'vue-star-rating'

export default {
    props: {
        name: {
            type: String,
            required: true
        },
        defaultRating: {
            type: Number,
            required: true
        }
    },
    components: {
        StarRating
    },
    data() {
        return {
            rating: this.defaultRating,
        }
    },
    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        setRating: function(rating){
            this.rating = parseInt(rating);
        }
    }
}
</script>

<template>
    <div>
        <input type="hidden" :name="`${name}`" :value="rating">
        <star-rating v-bind="$attrs" :rating="rating" :show-rating="false" @rating-selected="setRating"></star-rating>
    </div>
</template>